import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './header.css';
import App from './App';
import './service.css'
import './responsive.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
